<template>
    <FormFileInputField
        v-model="value"
        :is-uploading="isUploading"
        :invalid="!meta.valid && meta.validated"
        :error-message="errorMessage ? t(errorMessage) : undefined"
        :max-file-size-in-bytes="maxFileSizeInBytes"
    />
</template>

<script setup lang="ts">
import FormFileInputField from '@/components/form-inputs/form-file-input-field/FormFileInputField.vue'
import { useField } from 'vee-validate'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    name: string

    isUploading?: boolean
    maxFileSizeInBytes?: number
}>()

const { t } = useI18n()
const { value, errorMessage, meta } = useField<File | undefined>(() => props.name)
</script>
